module.exports = __webpack_public_path__ + "static/media/wave-bg.06fe1be3.svg";